export default "__VITE_ASSET__ZAWw0SeT__"